import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import CHIKU_DESKTOP from './assets/chiku-desktop.svg';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './ChikuHeroDesktop.scss';

const propTypes = {
    className: PropTypes.string,
};

function ChikuHeroDeskTop(props) {
    const {
        className = '',
    } = props;

    return (
        <img
            alt="chiku-desktop"
            className={classNames(styles.chikuDesktop, className)}
            height={80}
            src={CHIKU_DESKTOP}
            width={132}
        />
    );
}

ChikuHeroDeskTop.propTypes = propTypes;

export {
    ChikuHeroDeskTop,
};
export default ChikuHeroDeskTop;
